const Labels = require('./Labels.js');
const BlobMetaData = require('./BlobMetaData.js');
const Conversation = require('./Conversation.js');
const ConversationSummary = require('./ConversationSummary.js');
const ConversationSummaries = require ('./ConversationSummaries.js');
const Message = require ('./Message.js');
const Avatar = require('./Avatar.js');
const Task = require('./Task.js');
const { v4: uuidv4 } = require('uuid');

var test_summary_count = 2;

export function getLabels()
{
    var ret = new Labels();

    ret.upsert([
        { endpoint: "E164:+14801160001", label: "Jane Doe" },
        { endpoint: "E164:+14801160002", label: "Roger Smith" },
        { endpoint: "E164:+14801160003", label: "Allen Thomas" },
        { endpoint: "E164:+14801160004", label: "Allie Morgan" },

        { endpoint: "E164:+16027510001", label: "Mary Watts" },
        { endpoint: "E164:+16022231449", label: "Mary Watts" },
        
        { endpoint: "E164:+16027510002", label: "Bob Martin" },
        { endpoint: "E164:+16027510003", label: "Eric Wheeler" },

        { endpoint: "E164:+15020070001", label: "Mary Watts" },
        { endpoint: "E164:+15020070002", label: "Bob Martin" },
        { endpoint: "E164:+15020070003", label: "Eric Wheeler" },

        { endpoint: "E164:+19284120001", label: "Red Rock Realty Bot" },
        { endpoint: "E164:+19284120002", label: "Red Country Jeep Tours Bot" },
    ]);
    
    return ret;
}

export function getAvatar()
{
  return new Avatar("Some Avatar",'E164:+16027510001');
}

export function getConversationSummaryJson()
{
    return {
        "summary_id" : "4ccdcd34-566f-4532-add3-e6b4d2284a2a",
        "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
        "conversation_id" : "5cc01aae-66b5-4e6b-9edf-05c7c62ef294",
        "for_endpoint" : "E164:+16027510001",
        "all_conversation_endpoints_array" : [ "E164:+14801160001", "E164:+16027510001" ],
        "last_message_from" : "E164:+16027510001",
        "last_message_text" : "Perfect!",
        "last_message_time" : 1590078963500,
        read: true,
        archived: false
    };
}

export function getConversationSummariesJson()
{
    return [ {
        "summary_id" : "e7864d94-cdf5-4bd9-bde0-eda6f6ae365f",
        "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
        "conversation_id" : "b2b9a1d6-7a54-474f-9483-070a0552b431",
        "for_endpoint" : "E164:+16027510001",
        "all_conversation_endpoints_array" : [ "E164:+14801160002", "E164:+16027510001" ],
        "last_message_from" : "E164:+14801160002",
        "last_message_text" : "Great, got it.  Thanks!",
        "last_message_time" : 1590078971000,
        read: true,
        archived: false
      }, {
        "summary_id" : "5edeb454-f2af-4096-97e6-6b473af7efd6",
        "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
        "conversation_id" : "19c5551a-96f4-4190-830a-7ccba6ffb3d9",
        "for_endpoint" : "E164:+16027510001",
        "all_conversation_endpoints_array" : [ "E164:+14801160001", "E164:+16027510001" ],
        "last_message_from" : "E164:+16027510001",
        "last_message_text" : "Perfect!",
        "last_message_time" : 1590078963500,
        read: false,
        archived: false
      } ];
}

export function getConversationSummariesLongJson()
{
   let ret = getConversationSummariesJson();

   for ( let i = 0; i < 100; i++ )
   {
     ret.push({
      "summary_id" : uuidv4(),
      "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
      "conversation_id" : uuidv4(),
      "for_endpoint" : "E164:+16027510001",
      "all_conversation_endpoints_array" : [ "E164:+14801160002", "E164:+16027510001" ],
      "last_message_from" : "E164:+14801160002",
      "last_message_text" : "Message #"+i,
      "last_message_time" : 1590068871000-i*45000000,
      read: i%2 == 0,
      archived: false
    });
   }

   return ret;
}


export function getConversationSummary()
{
    return new ConversationSummary(getConversationSummaryJson(), getLabels());
}

export function getConversationSummaries()
{
    return new ConversationSummaries("E164:+16027510001", getConversationSummariesJson(), getLabels());
}

export function getConversationSummariesLong()
{
    return new ConversationSummaries("E164:+16027510001", getConversationSummariesLongJson(), getLabels());
}

export function getConversationSummariesBig()
{
  let big_json = getConversationSummariesJson();

  while(big_json.length < 100)
  {
    big_json = big_json.concat(getConversationSummariesJson());
  }

  return new ConversationSummaries("E164:+16027510001", big_json, getLabels());
}

export function getMessageJson()
{
    return {
      "message_id" : "28803e62-3855-4112-9697-4ffbcf75ad01",
      "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
      "conversation_id" : "c250dbda-b0d9-4c65-b7b4-915b8036ef0b",
      "author" : "E164:+16022231449",
      "time" : 1590078963500,
      "content_type" : "text/plain",
      "content" : "Perfect!",
      "state" : "delivered",
    };
}

export function getMessageFileJson()
{
  return {
    "message_id" : "778c03c3-39cc-4c35-a381-2bd5034b20af",
    "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
    "conversation_id" : "54a189fe-a1e2-474d-bdbd-9ede6af38a71",
    "author" : "E164:+16022231449",
    "time" : 1590078984500,
    "content_type" : "application/redchirp-file",
    "content" : "{\n  \"organization_id\" : \"8a732595-6621-4d6d-af37-0819110ae721\",\n  \"blob_id\" : \"e2c43a39-0f86-4519-b72d-fed1d4e99c3e\",\n  \"uploaded_by_employee_id\" : \"bbd1cd62-5a31-445d-b912-67e3aa024a77\",\n  \"purpose\" : \"attachment\",\n  \"is_archived\" : false,\n  \"uploaded_time\" : 1593452352514,\n  \"size_in_bytes\" : 18958,\n  \"content_type\" : \"application/pdf\",\n  \"label\" : \"Hello World.pdf\",\n  \"natural_filename\" : \"hello-world.pdf\"\n}",
    "state" : "delivered",
  };
}

export function getMessageImageJson()
{
  return {
    "message_id" : "783d8a80-cd86-4108-a67d-1850be7bd7cd",
    "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
    "conversation_id" : "54a189fe-a1e2-474d-bdbd-9ede6af38a71",
    "author" : "E164:+16022231449",
    "time" : 1590078983000,
    "content_type" : "application/redchirp-image",
    "content" : "{\n  \"organization_id\" : \"8a732595-6621-4d6d-af37-0819110ae721\",\n  \"blob_id\" : \"6df475e7-fed0-4f7b-ab5f-9c3e31da8d54\",\n  \"uploaded_by_employee_id\" : \"bbd1cd62-5a31-445d-b912-67e3aa024a77\",\n  \"purpose\" : \"attachment\",\n  \"is_archived\" : false,\n  \"uploaded_time\" : 1593452352514,\n  \"size_in_bytes\" : 964758,\n  \"content_type\" : \"image/jpeg\",\n  \"label\" : \"Frog Picture.jpg\",\n  \"natural_filename\" : \"frog-picture.jpg\"\n}",
    "state" : "delivered",
  };
}

export function getConversationJson()
{
  return {
    "conversation_definition" : {
      "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
      "conversation_id" : "457ab2c2-2012-4525-9968-0304653e885c",
      "endpoints" : [ "E164:+14801160002", "E164:+16022231449" ]
    },
    "messages" : [ {
      "message_id" : "1d1d24b5-9a94-4a78-8925-b2f14a8a62b4",
      "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
      "conversation_id" : "457ab2c2-2012-4525-9968-0304653e885c",
      "author" : "E164:+14801160002",
      "time" : 1590078971000,
      "content_type" : "text/plain",
      "content" : "Great, got it.  Thanks!",
      "state" : "delivered",
    }, {
      "message_id" : "0c78e077-2905-43b0-97fa-f9080d64f1b4",
      "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
      "conversation_id" : "457ab2c2-2012-4525-9968-0304653e885c",
      "author" : "E164:+16022231449",
      "time" : 1590078969500,
      "content_type" : "text/plain",
      "content" : "It is in the hose bib",
      "state" : "delivered",
    }, {
      "message_id" : "1cb343f1-f420-46fc-a365-1d91a04a08b2",
      "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
      "conversation_id" : "457ab2c2-2012-4525-9968-0304653e885c",
      "author" : "E164:+14801160002",
      "time" : 1590078968000,
      "content_type" : "text/plain",
      "content" : "We are at the house, but can't find the key...",
      "state" : "delivered",
    }, {
      "message_id" : "1c9aae68-d2c7-43e7-b054-5fa0fe011ef1",
      "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
      "conversation_id" : "457ab2c2-2012-4525-9968-0304653e885c",
      "author" : "E164:+16022231449",
      "time" : 1590078966500,
      "content_type" : "text/plain",
      "content" : "Hello! What can I help you with?",
      "state" : "delivered",
    }, {
      "message_id" : "8a298be6-80d7-4dd7-82af-4bef624b8d49",
      "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
      "conversation_id" : "457ab2c2-2012-4525-9968-0304653e885c",
      "author" : "E164:+14801160002",
      "time" : 1590078965000,
      "content_type" : "text/plain",
      "content" : "Hi, I am your renter for the house on Privett drive",
      "state" : "delivered",
    } ],
    "labels" : [ {
      "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
      "contact_id" : "36dfcae5-0c01-403e-98ea-cc0b26a75ee8",
      "endpoint" : "E164:+14801160002",
      "label" : "Roger Smith"
    }, {
      "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
      "contact_id" : "e68db660-db78-420a-a577-2115c8d43272",
      "endpoint" : "E164:+16022231449",
      "label" : "Mary Watts"
    } ]
  };
}

export function getMessage()
{
    return new Message(getMessageJson(),getLabels());
}

export function getMessageFile()
{
    return new Message(getMessageFileJson(),getLabels());
}

export function getMessageImage()
{
    return new Message(getMessageImageJson(),getLabels());
}

export function getBlobMetaData()
{
  return new BlobMetaData({
    "organization_id" : "00000000-0000-0000-0000-000000000000",
    "blob_id" : "00000000-0000-0000-0000-000000000001",
    "uploaded_by_employee_id" : "00000000-0000-0000-0000-000000000002",
    "purpose" : "attachment",
    "is_archived" : true,
    "uploaded_time" : 5,
    "size_in_bytes" : 6,
    "content_type" : "image/jpeg",
    "label" : "some-string-8",
    "natural_filename" : "some-string-8.jpg"
  });
}

export function getConversation()
{
    return new Conversation(getConversationJson(),getLabels());
}

export function getConversationBig()
{
  let message_count = 0;
  let time = 1590078963500;

  let big_json = [];

  function createMessage(author)
  {
    message_count++;
    time += 3500;
    
    let state = "delivered";

    if ( message_count == 3 )
      state = "in-transit";

    if ( message_count == 4 )
      state = "error";

    if ( message_count == 5 )
    {
      return {
        "message_id" : uuidv4(),
        "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
        "conversation_id" : "e989450a-9d3d-4828-8285-e3c08d010325",
        "author" : author,
        "time" : time,
        "content_type" : "text/plain",
        "content" : message_count == 2 ? "http://www.this.is.a.really.long.domain.com/thisisareallylongurlthatmightcauselinewrapissues.html" : "Message #"+message_count,
        "state" : state,
      };
    }

    return {
      "message_id" : uuidv4(),
      "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
      "conversation_id" : "e989450a-9d3d-4828-8285-e3c08d010325",
      "author" : author,
      "time" : time,
      "content_type" : "text/plain",
      "content" : message_count == 2 ? "http://www.this.is.a.really.long.domain.com/thisisareallylongurlthatmightcauselinewrapissues.html" : "Message #"+message_count,
      "state" : state,
    };
  }

  while(big_json.length < 200)
  {
    big_json.push(createMessage("E164:+16022231449"));
    big_json.push(createMessage("E164:+16022231449"));

    big_json.push(createMessage("E164:+14801160002"));
    big_json.push(createMessage("E164:+14801160002"));
    big_json.push(createMessage("E164:+14801160002"));
  }

  let conversation_json = {
    "conversation_definition": {
      "organization_id": "8a732595-6621-4d6d-af37-0819110ae721",
      "conversation_id": "6a707da0-0b33-413e-bf45-93cbfd4e9667",
      "endpoints": [
        "E164:+14801160002",
        "E164:+16022231449"
      ]
    },

    messages: big_json
  }

  return new Conversation(conversation_json, getLabels());
}

export function getTaskJson()
{
  return {
    "id" : "00000000-0000-0000-0000-000000000000",
    "account_id" : "00000000-0000-0000-0000-000000000001",
    "details" : {
      "type" : "standard-contact-customer",
      "consumer_name" : "Jim Kane",
      "consumer_endpoint" : "E164:+13152123517",
      "role_codes" : [ "builtin:sales" ]
    },
    "events" : [ {
      "type" : "event-open",
      "event_time" : 1591819133205
    } ],
    "state" : "open",
    "time_open" : 1591819133205
  };
}

export function getTask()
{
  return new Task(getTaskJson());
}


// This function was generated by ConceptTimeZoneTest.printAllTimeZonesForTestDataJS
export function getAllTimeZones()
{
  return ["Africa/Abidjan", "Africa/Accra", "Africa/Addis_Ababa", "Africa/Algiers", "Africa/Asmara", "Africa/Asmera", "Africa/Bamako", "Africa/Bangui", "Africa/Banjul", "Africa/Bissau", "Africa/Blantyre", "Africa/Brazzaville", "Africa/Bujumbura", "Africa/Cairo", "Africa/Casablanca", "Africa/Ceuta", "Africa/Conakry", "Africa/Dakar", "Africa/Dar_es_Salaam", "Africa/Djibouti", "Africa/Douala", "Africa/El_Aaiun", "Africa/Freetown", "Africa/Gaborone", "Africa/Harare", "Africa/Johannesburg", "Africa/Juba", "Africa/Kampala", "Africa/Khartoum", "Africa/Kigali", "Africa/Kinshasa", "Africa/Lagos", "Africa/Libreville", "Africa/Lome", "Africa/Luanda", "Africa/Lubumbashi", "Africa/Lusaka", "Africa/Malabo", "Africa/Maputo", "Africa/Maseru", "Africa/Mbabane", "Africa/Mogadishu", "Africa/Monrovia", "Africa/Nairobi", "Africa/Ndjamena", "Africa/Niamey", "Africa/Nouakchott", "Africa/Ouagadougou", "Africa/Porto-Novo", "Africa/Sao_Tome", "Africa/Timbuktu", "Africa/Tripoli", "Africa/Tunis", "Africa/Windhoek", "America/Adak", "America/Anchorage", "America/Anguilla", "America/Antigua", "America/Araguaina", "America/Argentina/Buenos_Aires", "America/Argentina/Catamarca", "America/Argentina/ComodRivadavia", "America/Argentina/Cordoba", "America/Argentina/Jujuy", "America/Argentina/La_Rioja", "America/Argentina/Mendoza", "America/Argentina/Rio_Gallegos", "America/Argentina/Salta", "America/Argentina/San_Juan", "America/Argentina/San_Luis", "America/Argentina/Tucuman", "America/Argentina/Ushuaia", "America/Aruba", "America/Asuncion", "America/Atikokan", "America/Atka", "America/Bahia", "America/Bahia_Banderas", "America/Barbados", "America/Belem", "America/Belize", "America/Blanc-Sablon", "America/Boa_Vista", "America/Bogota", "America/Boise", "America/Buenos_Aires", "America/Cambridge_Bay", "America/Campo_Grande", "America/Cancun", "America/Caracas", "America/Catamarca", "America/Cayenne", "America/Cayman", "America/Chicago", "America/Chihuahua", "America/Ciudad_Juarez", "America/Coral_Harbour", "America/Cordoba", "America/Costa_Rica", "America/Creston", "America/Cuiaba", "America/Curacao", "America/Danmarkshavn", "America/Dawson", "America/Dawson_Creek", "America/Denver", "America/Detroit", "America/Dominica", "America/Edmonton", "America/Eirunepe", "America/El_Salvador", "America/Ensenada", "America/Fort_Nelson", "America/Fort_Wayne", "America/Fortaleza", "America/Glace_Bay", "America/Godthab", "America/Goose_Bay", "America/Grand_Turk", "America/Grenada", "America/Guadeloupe", "America/Guatemala", "America/Guayaquil", "America/Guyana", "America/Halifax", "America/Havana", "America/Hermosillo", "America/Indiana/Indianapolis", "America/Indiana/Knox", "America/Indiana/Marengo", "America/Indiana/Petersburg", "America/Indiana/Tell_City", "America/Indiana/Vevay", "America/Indiana/Vincennes", "America/Indiana/Winamac", "America/Indianapolis", "America/Inuvik", "America/Iqaluit", "America/Jamaica", "America/Jujuy", "America/Juneau", "America/Kentucky/Louisville", "America/Kentucky/Monticello", "America/Knox_IN", "America/Kralendijk", "America/La_Paz", "America/Lima", "America/Los_Angeles", "America/Louisville", "America/Lower_Princes", "America/Maceio", "America/Managua", "America/Manaus", "America/Marigot", "America/Martinique", "America/Matamoros", "America/Mazatlan", "America/Mendoza", "America/Menominee", "America/Merida", "America/Metlakatla", "America/Mexico_City", "America/Miquelon", "America/Moncton", "America/Monterrey", "America/Montevideo", "America/Montreal", "America/Montserrat", "America/Nassau", "America/New_York", "America/Nipigon", "America/Nome", "America/Noronha", "America/North_Dakota/Beulah", "America/North_Dakota/Center", "America/North_Dakota/New_Salem", "America/Nuuk", "America/Ojinaga", "America/Panama", "America/Pangnirtung", "America/Paramaribo", "America/Phoenix", "America/Port-au-Prince", "America/Port_of_Spain", "America/Porto_Acre", "America/Porto_Velho", "America/Puerto_Rico", "America/Punta_Arenas", "America/Rainy_River", "America/Rankin_Inlet", "America/Recife", "America/Regina", "America/Resolute", "America/Rio_Branco", "America/Rosario", "America/Santa_Isabel", "America/Santarem", "America/Santiago", "America/Santo_Domingo", "America/Sao_Paulo", "America/Scoresbysund", "America/Shiprock", "America/Sitka", "America/St_Barthelemy", "America/St_Johns", "America/St_Kitts", "America/St_Lucia", "America/St_Thomas", "America/St_Vincent", "America/Swift_Current", "America/Tegucigalpa", "America/Thule", "America/Thunder_Bay", "America/Tijuana", "America/Toronto", "America/Tortola", "America/Vancouver", "America/Virgin", "America/Whitehorse", "America/Winnipeg", "America/Yakutat", "America/Yellowknife", "Antarctica/Casey", "Antarctica/Davis", "Antarctica/DumontDUrville", "Antarctica/Macquarie", "Antarctica/Mawson", "Antarctica/McMurdo", "Antarctica/Palmer", "Antarctica/Rothera", "Antarctica/South_Pole", "Antarctica/Syowa", "Antarctica/Troll", "Antarctica/Vostok", "Arctic/Longyearbyen", "Asia/Aden", "Asia/Almaty", "Asia/Amman", "Asia/Anadyr", "Asia/Aqtau", "Asia/Aqtobe", "Asia/Ashgabat", "Asia/Ashkhabad", "Asia/Atyrau", "Asia/Baghdad", "Asia/Bahrain", "Asia/Baku", "Asia/Bangkok", "Asia/Barnaul", "Asia/Beirut", "Asia/Bishkek", "Asia/Brunei", "Asia/Calcutta", "Asia/Chita", "Asia/Choibalsan", "Asia/Chongqing", "Asia/Chungking", "Asia/Colombo", "Asia/Dacca", "Asia/Damascus", "Asia/Dhaka", "Asia/Dili", "Asia/Dubai", "Asia/Dushanbe", "Asia/Famagusta", "Asia/Gaza", "Asia/Harbin", "Asia/Hebron", "Asia/Ho_Chi_Minh", "Asia/Hong_Kong", "Asia/Hovd", "Asia/Irkutsk", "Asia/Istanbul", "Asia/Jakarta", "Asia/Jayapura", "Asia/Jerusalem", "Asia/Kabul", "Asia/Kamchatka", "Asia/Karachi", "Asia/Kashgar", "Asia/Kathmandu", "Asia/Katmandu", "Asia/Khandyga", "Asia/Kolkata", "Asia/Krasnoyarsk", "Asia/Kuala_Lumpur", "Asia/Kuching", "Asia/Kuwait", "Asia/Macao", "Asia/Macau", "Asia/Magadan", "Asia/Makassar", "Asia/Manila", "Asia/Muscat", "Asia/Nicosia", "Asia/Novokuznetsk", "Asia/Novosibirsk", "Asia/Omsk", "Asia/Oral", "Asia/Phnom_Penh", "Asia/Pontianak", "Asia/Pyongyang", "Asia/Qatar", "Asia/Qostanay", "Asia/Qyzylorda", "Asia/Rangoon", "Asia/Riyadh", "Asia/Saigon", "Asia/Sakhalin", "Asia/Samarkand", "Asia/Seoul", "Asia/Shanghai", "Asia/Singapore", "Asia/Srednekolymsk", "Asia/Taipei", "Asia/Tashkent", "Asia/Tbilisi", "Asia/Tehran", "Asia/Tel_Aviv", "Asia/Thimbu", "Asia/Thimphu", "Asia/Tokyo", "Asia/Tomsk", "Asia/Ujung_Pandang", "Asia/Ulaanbaatar", "Asia/Ulan_Bator", "Asia/Urumqi", "Asia/Ust-Nera", "Asia/Vientiane", "Asia/Vladivostok", "Asia/Yakutsk", "Asia/Yangon", "Asia/Yekaterinburg", "Asia/Yerevan", "Atlantic/Azores", "Atlantic/Bermuda", "Atlantic/Canary", "Atlantic/Cape_Verde", "Atlantic/Faeroe", "Atlantic/Faroe", "Atlantic/Jan_Mayen", "Atlantic/Madeira", "Atlantic/Reykjavik", "Atlantic/South_Georgia", "Atlantic/St_Helena", "Atlantic/Stanley", "Australia/ACT", "Australia/Adelaide", "Australia/Brisbane", "Australia/Broken_Hill", "Australia/Canberra", "Australia/Currie", "Australia/Darwin", "Australia/Eucla", "Australia/Hobart", "Australia/LHI", "Australia/Lindeman", "Australia/Lord_Howe", "Australia/Melbourne", "Australia/NSW", "Australia/North", "Australia/Perth", "Australia/Queensland", "Australia/South", "Australia/Sydney", "Australia/Tasmania", "Australia/Victoria", "Australia/West", "Australia/Yancowinna", "Brazil/Acre", "Brazil/DeNoronha", "Brazil/East", "Brazil/West", "CET", "CST6CDT", "Canada/Atlantic", "Canada/Central", "Canada/Eastern", "Canada/Mountain", "Canada/Newfoundland", "Canada/Pacific", "Canada/Saskatchewan", "Canada/Yukon", "Chile/Continental", "Chile/EasterIsland", "Cuba", "EET", "EST5EDT", "Egypt", "Eire", "Etc/GMT", "Etc/GMT+0", "Etc/GMT+1", "Etc/GMT+10", "Etc/GMT+11", "Etc/GMT+12", "Etc/GMT+2", "Etc/GMT+3", "Etc/GMT+4", "Etc/GMT+5", "Etc/GMT+6", "Etc/GMT+7", "Etc/GMT+8", "Etc/GMT+9", "Etc/GMT-0", "Etc/GMT-1", "Etc/GMT-10", "Etc/GMT-11", "Etc/GMT-12", "Etc/GMT-13", "Etc/GMT-14", "Etc/GMT-2", "Etc/GMT-3", "Etc/GMT-4", "Etc/GMT-5", "Etc/GMT-6", "Etc/GMT-7", "Etc/GMT-8", "Etc/GMT-9", "Etc/GMT0", "Etc/Greenwich", "Etc/UCT", "Etc/UTC", "Etc/Universal", "Etc/Zulu", "Europe/Amsterdam", "Europe/Andorra", "Europe/Astrakhan", "Europe/Athens", "Europe/Belfast", "Europe/Belgrade", "Europe/Berlin", "Europe/Bratislava", "Europe/Brussels", "Europe/Bucharest", "Europe/Budapest", "Europe/Busingen", "Europe/Chisinau", "Europe/Copenhagen", "Europe/Dublin", "Europe/Gibraltar", "Europe/Guernsey", "Europe/Helsinki", "Europe/Isle_of_Man", "Europe/Istanbul", "Europe/Jersey", "Europe/Kaliningrad", "Europe/Kiev", "Europe/Kirov", "Europe/Kyiv", "Europe/Lisbon", "Europe/Ljubljana", "Europe/London", "Europe/Luxembourg", "Europe/Madrid", "Europe/Malta", "Europe/Mariehamn", "Europe/Minsk", "Europe/Monaco", "Europe/Moscow", "Europe/Nicosia", "Europe/Oslo", "Europe/Paris", "Europe/Podgorica", "Europe/Prague", "Europe/Riga", "Europe/Rome", "Europe/Samara", "Europe/San_Marino", "Europe/Sarajevo", "Europe/Saratov", "Europe/Simferopol", "Europe/Skopje", "Europe/Sofia", "Europe/Stockholm", "Europe/Tallinn", "Europe/Tirane", "Europe/Tiraspol", "Europe/Ulyanovsk", "Europe/Uzhgorod", "Europe/Vaduz", "Europe/Vatican", "Europe/Vienna", "Europe/Vilnius", "Europe/Volgograd", "Europe/Warsaw", "Europe/Zagreb", "Europe/Zaporozhye", "Europe/Zurich", "GB", "GB-Eire", "GMT", "GMT0", "Greenwich", "Hongkong", "Iceland", "Indian/Antananarivo", "Indian/Chagos", "Indian/Christmas", "Indian/Cocos", "Indian/Comoro", "Indian/Kerguelen", "Indian/Mahe", "Indian/Maldives", "Indian/Mauritius", "Indian/Mayotte", "Indian/Reunion", "Iran", "Israel", "Jamaica", "Japan", "Kwajalein", "Libya", "MET", "MST7MDT", "Mexico/BajaNorte", "Mexico/BajaSur", "Mexico/General", "NZ", "NZ-CHAT", "Navajo", "PRC", "PST8PDT", "Pacific/Apia", "Pacific/Auckland", "Pacific/Bougainville", "Pacific/Chatham", "Pacific/Chuuk", "Pacific/Easter", "Pacific/Efate", "Pacific/Enderbury", "Pacific/Fakaofo", "Pacific/Fiji", "Pacific/Funafuti", "Pacific/Galapagos", "Pacific/Gambier", "Pacific/Guadalcanal", "Pacific/Guam", "Pacific/Honolulu", "Pacific/Johnston", "Pacific/Kanton", "Pacific/Kiritimati", "Pacific/Kosrae", "Pacific/Kwajalein", "Pacific/Majuro", "Pacific/Marquesas", "Pacific/Midway", "Pacific/Nauru", "Pacific/Niue", "Pacific/Norfolk", "Pacific/Noumea", "Pacific/Pago_Pago", "Pacific/Palau", "Pacific/Pitcairn", "Pacific/Pohnpei", "Pacific/Ponape", "Pacific/Port_Moresby", "Pacific/Rarotonga", "Pacific/Saipan", "Pacific/Samoa", "Pacific/Tahiti", "Pacific/Tarawa", "Pacific/Tongatapu", "Pacific/Truk", "Pacific/Wake", "Pacific/Wallis", "Pacific/Yap", "Poland", "Portugal", "ROK", "Singapore", "SystemV/AST4", "SystemV/AST4ADT", "SystemV/CST6", "SystemV/CST6CDT", "SystemV/EST5", "SystemV/EST5EDT", "SystemV/HST10", "SystemV/MST7", "SystemV/MST7MDT", "SystemV/PST8", "SystemV/PST8PDT", "SystemV/YST9", "SystemV/YST9YDT", "Turkey", "UCT", "America/Anchorage", "US/Aleutian", "America/Phoenix", "America/Chicago", "US/East-Indiana", "America/New_York", "Pacific/Honolulu", "US/Indiana-Starke", "US/Michigan", "America/Denver", "America/Los_Angeles", "Pacific/Pago_Pago", "UTC", "Universal", "W-SU", "WET", "Zulu", "EST", "HST", "MST", "ACT", "AET", "AGT", "America/Argentina/Cordoba", "AST", "BET", "BST", "CAT", "CNT", "CST", "CTT", "EAT", "ECT", "IET", "IST", "JST", "MIT", "NET", "NST", "PLT", "PNT", "PRT", "PST", "SST", "VST"];
}

// This function was generated by ConceptTimeZoneTest.printCommonUSTimeZonesForTestDataJS
export function getCommonTimeZones()
{
  return [{'text': 'Eastern Time: New York', 'value': 'America/New_York'}, {'text': 'Central Time: Chicago', 'value': 'America/Chicago'}, {'text': 'Mountain Time: Denver', 'value': 'America/Denver'}, {'text': 'Mountain Time: Phoenix', 'value': 'America/Phoenix'}, {'text': 'Pacific Time: Los Angeles', 'value': 'America/Los_Angeles'}, {'text': 'Alaska Time: Anchorage', 'value': 'America/Anchorage'}, {'text': 'Hawaii Time: Honolulu', 'value': 'Pacific/Honolulu'}, {'text': 'Samoa Time: Pago Pago', 'value': 'Pacific/Pago_Pago'}, {'text': 'Chamorro Time: Guam', 'value': 'Pacific/Guam'}];
}

export default { 
  getAvatar, 
  getConversationSummaries, 
  getConversationSummary, 
  getConversationSummariesJson, 
  getConversationSummaryJson, 
  getLabels, 
  getMessage, 
  getMessageJson, 
  getConversationJson, 
  getConversation,
  getConversationSummariesBig,
  getConversationBig,
  getTaskJson,
  getTask,
  getMessageFileJson,
  getMessageImageJson,
  getMessageFile,
  getMessageImage,
  getBlobMetaData,
  getConversationSummariesLong,
  getAllTimeZones,
  getCommonTimeZones,
  getConversationSummariesLongJson
};

